import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#FAFAFA] flex items-center justify-center px-6">
      <div className="text-center fade-up" data-testid="payment-cancel-screen">
        <XCircle size={56} className="text-zinc-300 mx-auto mb-6" />
        <h1 className="font-heading font-extrabold text-3xl tracking-tight">Pagamento cancelado</h1>
        <p className="text-zinc-600 mt-4 max-w-sm mx-auto">Sem problemas — nada foi cobrado. Você pode assinar o Pro quando quiser.</p>
        <div className="flex gap-3 justify-center mt-8">
          <Link data-testid="cancel-pricing-btn" to="/pricing" className="px-6 py-3 bg-[#FF4F00] text-white rounded-full font-semibold text-sm hover:bg-[#E64600] transition-colors">
            Ver planos
          </Link>
          <Link data-testid="cancel-dashboard-btn" to="/dashboard" className="px-6 py-3 border border-zinc-300 rounded-full font-semibold text-sm text-zinc-800 hover:border-zinc-500 transition-colors">
            Ir para o painel
          </Link>
        </div>
      </div>
    </div>
  );
}
